export default __webpack_public_path__ + "static/media/clips_download.29144256.png";